function isSelectListItem(item) {
    return typeof item === 'object' && (Object.prototype.hasOwnProperty.call(item, 'enableUpdate')
        || Object.prototype.hasOwnProperty.call(item, 'disabled'));
}
function isObjectItem(item) {
    return typeof item === 'object';
}
function listPlacement(listTop = false, listRight = false) {
    switch (true) {
        case listTop && listRight: return 'top-end';
        case listTop && !listRight: return 'top';
        case !listTop && listRight: return 'bottom-end';
        default: return 'bottom-start';
    }
}

export { isObjectItem, isSelectListItem, listPlacement };
